var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.showDefault &&
    _vm.$store.state.currentUser &&
    _vm.$store.state.currentUser.user
    ? _c("div", { staticClass: "avatar avatar-sm profile-cover-avatar" }, [
        _c("img", {
          staticClass: "avatar-img",
          attrs: { src: _vm.avatarURL, alt: "Profile Image" },
        }),
      ])
    : _c("div", { staticClass: "is-flex-desktop is-vcentered" }, [
        _vm.showDefault
          ? _c("img", {
              staticClass: "avatar-img",
              attrs: {
                src: require("@/ui/assets/img/user-generic.png"),
                alt: "Profile Image",
              },
            })
          : _vm._e(),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }